import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/manga";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-2 cursor-pointer"
          aria-label="包子漫画排行榜 首页"
        >
          <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
            包
          </span>
          <span
            className={`font-heading text-lg font-bold tracking-wide transition-colors ${
              scrolled || open ? "text-foreground-950" : "text-background-50"
            }`}
          >
            包子漫画
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-7">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`text-sm font-label transition-colors cursor-pointer ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600"
                    : "text-background-50/90 hover:text-background-50"
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#ranking"
          className="hidden lg:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-trophy-line text-base" aria-hidden="true"></i>
          看人气榜
        </a>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开导航菜单"
          aria-expanded={open}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
            scrolled || open ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <ul className="flex flex-col">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block py-2.5 text-sm font-label text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#ranking"
            onClick={() => setOpen(false)}
            className="mt-2 block text-center px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium cursor-pointer"
          >
            看人气榜
          </a>
        </div>
      )}
    </header>
  );
}